import { breakpointUp } from './breakpoints'
import gsap from 'gsap'

export function setUpHeader(locoScroll) {

  //-- Show Hide on Scroll ---
  let doc = document.documentElement;
  let w = window;
  let vH = window.innerHeight

  let prevScroll = w.scrollY || doc.scrollTop;
  let curScroll;
  let direction = 0;
  let prevDirection = 0;

  let header = document.querySelector('header');

  let checkScroll = function () {
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    } else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      if (direction === 2) {
        if (curScroll > 0)
          header.classList.add('hide');
      } else {
        header.classList.remove('hide');
      }
      prevDirection = direction;
    }

    if (curScroll > 100) {
      header.classList.add('white')
    } else {
      header.classList.remove('white')
    }

    prevScroll = curScroll;
  };


  //detect scroll and checkScroll
  if (breakpointUp('lg')) {
    // locoScroll.on('scroll', function(e){
    //   curScroll = Math.ceil(e.scroll.y)
    //   checkScroll()
    // })
  } else {
    window.addEventListener('scroll', function(){
      curScroll = w.scrollY || doc.scrollTop;
      checkScroll()
    });
  }

  // -- End show hide scroll --



  //-- open menu ---
  let menuPopup = '.js-main-nav'
  let wW = document.innerWidth

  let menuOut = gsap.timeline({paused: true})
  if (wW > 1200) {
    menuOut.to(menuPopup, { right: '-2rem', opacity: 0, duration: 0.4 })
  } else {
    menuOut.to(menuPopup, { top: '-2rem', opacity: 0, duration: 0.4 })
  }
  menuOut.set(menuPopup, { display: 'none' })

  let menuIn = gsap.timeline({paused: true})
    .set(menuPopup, {display: 'block'})
  if (wW > 1200) {
    menuIn.from(menuPopup, { right: '-2rem', opacity: 0, duration: 0.4 })
  } else {
    menuIn.from(menuPopup, { top: '-2rem', opacity: 0, duration: 0.4 })
  }

  $(menuPopup + " .nav-menu a").each(function(index, element){
    menuIn.from(element, 0.2, {top: '0.5rem', opacity: 0})
  })
  menuIn.from(menuPopup + ' .soc-menu', {bottom: '3rem', opacity: '0', duration: 0.4})

  $('.js-open-close-menu').click(function (){
    if ($(this).hasClass('opened')){
      closeMenu()
    } else {
      openMenu()
    }
  })

  // close menu on link click
  $('.navigation a').click(function (){
    closeMenu()
  })

  function closeMenu(){
    menuOut.restart()
    $('body').removeClass('modal-opened')
    $('.js-page-filter').fadeOut()
    if (breakpointUp('lg')) locoScroll.start()
    $('.js-open-close-menu').removeClass('opened')
  }
  function openMenu(){
    $('body').addClass('modal-opened')
    menuIn.restart()
    $('.js-page-filter').fadeIn()
    if (breakpointUp('lg')) locoScroll.stop()
    $('.js-open-close-menu').addClass('opened')
  }

}



